import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-are-you-sure-modal',
  templateUrl: './are-you-sure-modal.component.html',
  styleUrls: ['./are-you-sure-modal.component.scss'],
})
export class AreYouSureModalComponent implements OnInit {
  isChecked = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      body: string;
      showCheckbox?: boolean;
      checkboxMessage?: string;
      title: string;
      sku?: string;
      manufacturer?: string;
      confirmButton?: string;
      cancelButton?: string;
      hideCancelBtn?: boolean;
      showCloseIcon?: boolean;
    },
    public dialogRef: MatDialogRef<AreYouSureModalComponent>
  ) {}

  ngOnInit(): void {}

  confirm() {
    this.dialogRef.close({ confirmed: true, isChecked: this.isChecked });
  }

  close() {
    this.dialogRef.close({ closed: true });
  }
}
